const sliders = document.querySelectorAll('.support-slider__contents');

sliders.forEach((slider) => {
  const sliderCount = Number(slider.dataset.sliderCount) || 3;
  const sliderSpace = Number(slider.dataset.sliderSpace) || 12;

  const pagination = slider.querySelector('.support-pagination');
  const nextButton = slider.querySelector('.swiper-button-next-support');
  const prevButton = slider.querySelector('.swiper-button-prev-support');

  new Swiper(slider, {
    loop: true,
    slidesPerView: 1.52,
    spaceBetween: 12,

    pagination: {
      el: pagination,
      clickable: true,
    },

    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      enabled: true,
    },

    breakpoints: {
      580: {
        slidesPerView: 2,
      },
      980: {
        slidesPerView: sliderCount,
        spaceBetween: sliderSpace,
      }
    }
  });
});
